export const SERVICE_IMAGES = {
  assessoriaRh: '/images/servicos/assessoria-rh.png',
  facilities: '/images/servicos/facilities/facilities-real.webp',
  facilitiesFallback: '/images/servicos/facilities/facilities-real.webp',
  recrutamento: '/images/servicos/recrutamento-selecao/recrutamento-alt.jfif',
  limpeza: '/images/servicos/limpeza/limpeza.jpg',
  jardinagem: '/images/servicos/jardinagem/jardinagem-real.webp',
  maoDeObraTemporaria:
    '/images/servicos/mao-de-obra-temporaria/mao-de-obra-temporaria.jpg',
  maoDeObraEfetiva:
    '/images/servicos/mao-de-obra-efetiva/mao-de-obra-efetiva.jpg',
  terceirizacao: '/images/servicos/terceirizacao/terceirizacao-real.webp',
  controleAcesso:
    '/images/servicos/controle-acesso/galeria/controle-de-acesso.jpg',
  solucaoRh: '/images/servicos/solucao-rh.jfif',
  timeRh: '/images/servicos/solucao-rh.jfif',
  bancoTalentoReal: '/images/servicos/banco-de-talentos/banco-de-talentos.jpg',
  facilitiesReal: '/images/servicos/facilities/facilities-real.webp',
  limpezaReal: '/images/servicos/limpeza/limpeza.jpg',
  jardinagemReal: '/images/servicos/jardinagem/jardinagem-real.webp',
  maoDeObraReal:
    '/images/servicos/mao-de-obra-temporaria/mao-de-obra-temporaria.jpg',
  terceirizacaoReal: '/images/servicos/terceirizacao/terceirizacao-real.webp',
  servicosReal: '/images/hero/servicos-hero.webp',
  zeladoriaReal: '/images/servicos/zeladoria/zeladoria-real.png',
  faxinaReal: '/images/servicos/faxina-diarista/faxina.webp',
  limpezaPesadaReal: '/images/servicos/limpeza-pesada/limpeza-pesada.webp',
  limpezaFachadaReal:
    '/images/servicos/limpeza-de-fachada/limpeza-de-fachada.webp',
  limpezaVidrosReal:
    '/images/servicos/limpeza-de-vidros/limpeza-de-vidros.webp',
  limpezaPreMudancaReal:
    '/images/servicos/limpeza-pre-mudanca/limpeza-pre-mudanca.webp',
  limpezaPosMudancaReal:
    '/images/servicos/limpeza-pos-mudanca/limpeza-pos-mudanca.webp',
  limpezaPosObraReal: '/images/servicos/limpeza-pos-obra/limpeza-pos-obra.webp',
  limpezaDeManutencao: '/images/servicos/limpeza-de-manutencao.webp',
  trabalhoTemporizadoReal: '/images/servicos/trabalho-terceirizado.png',
  trabalhoFreeLanceReal: '/images/servicos/trabalho-freelance.png',
  avaliacaoPerfil: '/images/servicos/avaliacao-perfil/avaliacao-perfil.svg',
  hunting: '/images/servicos/hunting/hunting.svg',
  processoRh: '/images/servicos/solucao-rh.jfif',
  avaliacaoPerfilReal: '/images/servicos/avaliacao-perfil/avaliacao-perfil.jpg',
  huntingReal: '/images/servicos/hunting/executive-search.jpg',
  controleAcessoReal:
    '/images/servicos/controle-acesso/galeria/controle-de-acesso.jpg',
  processoRhReal: '/images/servicos/processo-de-rh/processo-de-rh.jpg',
  maoDeObraTemporariaReal:
    '/images/servicos/mao-de-obra-temporaria/mao-de-obra-temporaria.jpg',
  maoDeObraEfetivaReal:
    '/images/servicos/mao-de-obra-efetiva/mao-de-obra-efetiva.jpg',
  bancoTalentoRealJpg:
    '/images/servicos/banco-de-talentos/banco-de-talentos -real.jpg',
  terceirizacaoRealJpg:
    '/images/servicos/terceirizacao/terceirizacao-real.webp',
  zeladoriaRealJpg: '/images/servicos/zeladoria/zeladoria-real.png',
  limpezaRealJpg: '/images/servicos/limpeza/limpeza.jpg',
  limpezaAntes: '/images/servicos/limpeza/limpeza.jpg',
  portariaReal: '/images/servicos/portaria/recepcao-e-portaria.jpg',
} as const;

export const CANDIDATE_IMAGES = {
  cadastroCurriculo: '/images/candidatos/hero/cadastro-curriculo.png',
  buscaVagas: '/images/candidatos/hero/busca-vagas.png',
} as const;

export const FALLBACK_IMAGES = {
  servicos: '/images/servicos/fallbacks/servicos.png',
  vagas: '/images/fallbacks/vagas.png',
  contato: '/images/contato/fallbacks/contato.png',
} as const;

export const HERO_ASSETS = {
  cardheros: '/images/home/cards/cardheros.png',
  bannerjs: '/images/sobre/banner-js-empregos.jpg',
  homeSlides: [
    '/images/home/banners/banner-principal.webp',
    '/images/home/banners/banner-secundario.webp',
    '/images/home/banners/banner-terciario.png',
  ],
  servicos: '/images/home/sections/servicos-hero.webp',
  suporte: '/images/suporte/hero/suporte.webp',
  trabalheConosco: '/images/trabalhe-conosco/trabalhe-conosco.webp',
} as const;

export const SHOWCASE_SLIDES = [
  {
    src: HERO_ASSETS.cardheros,
    alt: 'J&S Empregos LTDA',
    objectPosition: 'center 30%',
  },
  {
    src: SERVICE_IMAGES.facilitiesReal,
    alt: 'Facilities e Terceirização',
    objectPosition: 'center',
  },
  {
    src: SERVICE_IMAGES.maoDeObraTemporariaReal,
    alt: 'Mão de Obra Temporária e Efetiva',
    objectPosition: 'center',
  },
  {
    src: SERVICE_IMAGES.limpezaReal,
    alt: 'Limpeza e Conservação',
    objectPosition: 'center 25%',
  },
  {
    src: SERVICE_IMAGES.jardinagemReal,
    alt: 'Jardinagem e Paisagismo',
    objectPosition: 'center',
  },
  {
    src: SERVICE_IMAGES.terceirizacaoReal,
    alt: 'Terceirização de Serviços',
    objectPosition: 'center',
  },
] as const;

export const PARTNER_ASSETS = {
  vectorEngenharia: '/images/parceiros/vector-engenharia.webp',
  mistral: '/images/parceiros/mistral.webp',
  cadrempresaspareceiras: '/images/parceiros/cadastro-empresas-pareceiras.png',
} as const;
